import HttpClient from "../client/httpclient";
import PaginatedData from "../client/PaginatedData";
import 'regenerator-runtime/runtime';
class PaginatedContent {
    constructor(DOMelement) {
        try {
            this.PageTitle = document.title;
            this.el = DOMelement;
            this.currentPage = 1;
            this.readMoreContentParentDiv;
            this.readMoreContentChildDiv;
            this.globalContentParentDiv;
            this.globalContentChildArr = [];
            this.pageFlag = false;

            function getParameterByName(name, url = window.location.href) {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }
            function isNumeric(str) {
                if (typeof str != "string") return false // we only process strings!  
                return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
            }
            var queryStringVal = getParameterByName('page');

            if (queryStringVal && isNumeric(queryStringVal) && queryStringVal != '1') {
                this.currentPage = parseInt(queryStringVal);
                document.querySelector("link[rel='canonical']").href = window.location.href;
            }

            this.aPrevPage = document.getElementById("aPrevPage");
            this.aNextPage = document.getElementById("aNextPage");

            this.totalPage = this.el.getAttribute("data-totalpages");
            this.totalResults = this.el.getAttribute("data-totalresults");
            this.resultType = this.el.getAttribute("data-resulttype");
            this.itemId = this.el.getAttribute("data-item");
            this.visibleItems = 3;
            this.url = this.el.getAttribute("data-action");
            this.isProductSearch = this.url.toLowerCase().indexOf("search") != -1;
            
            this.filteredValue = PaginatedData.getFilter();
            if (process.env.NODE_ENV === "development") {
                this.url = this.isProductSearch ? "/src/api/product-search-result.json" : "/src/api/teams-api-response.html";
            }

            this.tabInputs = document.querySelectorAll('[name="css-tabs"]');
            [...this.tabInputs].forEach((input) => {
                if (input.checked) {
                    this.selectedTabID = input.getAttribute("id");
                }
            })

            this.tab = document.querySelectorAll(".tab");
            [...this.tab].forEach((tab) => {
                let forValue = tab.children[0].getAttribute("for");
                if (forValue === this.selectedTabID) {
                    PaginatedData.setTab(tab.id);
                }
                tab.addEventListener("click", this.setTabValue);
            })
            this.method = "GET";

            this.contentId = this.el.getAttribute("data-pagination-id");
            this.contentEl = document.querySelector(`[data-content-id="${this.contentId}"]`);

            // stop execution when there in no pagination
            if (this.totalPage == 0) return false;
            this.originalText = document.getElementsByClassName("sd-h3")[0].innerHTML;

            this.navItems = this.el.querySelectorAll("li.sd-pagination__item");
            this.paginationList = this.el.querySelector('.sd-pagination__list');
            this.previousButton = this.el.querySelector(".sd-pagination__previous");
            this.nextButton = this.el.querySelector(".sd-pagination__next");
            this.setTabValue = this.setTabValue.bind(this);
            this.getDataFromAPI = this.getProductSearchDataFromAPI.bind(this);
            this.changePage = this.changePage.bind(this);
            this.setPaginationLink = this.setPaginationLink.bind(this);
            this.scrollToTop = this.scrollToTop.bind(this);
            this.next = this.next.bind(this);
            this.previous = this.previous.bind(this);
            this.getPaginatedData = this.getPaginatedData.bind(this);
            this.updatePagination = this.updatePagination.bind(this);
            this.generateItems = this.generateItems.bind(this);
            this.reAttachPaginationLinks = this.reAttachPaginationLinks.bind(this);

            if (this.previousButton) {
                this.previousButton.addEventListener("click", this.previous);
            }
            if (this.nextButton) {
                this.nextButton.addEventListener("click", this.next);
            }

            window.addEventListener('popstate',(event) => {
                let urlParams = new URLSearchParams(window.location.search);
                let urlPageParam = urlParams.get("page");
                if(urlPageParam){
                    this.changePage(event,urlPageParam);
                }
            });

            this.removeExistingPaginationLinks = this.removeExistingPaginationLinks.bind(this);

            //Pass the UpdatePagination function as a callback to allow filters to use it. This enables the filters to update the pagination navigation and update more dynamically/efficiently.
            PaginatedData.setUpdatePagination(this.updatePagination);
            PaginatedData.setReAttachPaginationLinks(this.reAttachPaginationLinks);

            this.checkANextPrev();
            //Page load for next button page href
            if (queryStringVal == null) {
                var searchParams = this.getSearchParamsFromURL();
                var queryChar = "?";
                if (searchParams.length > 1) {
                    queryChar = "&";
                }

                //Set URL of the accessed page
                let regex = /\/$/;
                var hostPath = window.location.host + window.location.pathname + searchParams;
                let result = hostPath.replace(regex, "");
                if (this.aNextPage) {
                    this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
                }
            }
            this.generateItems();
            this.currentTab = PaginatedData.getTab();
            PaginatedData.getFilteredResultCount(this.totalResults, this.resultType, this.contentId, parseInt(this.currentPage));
        } catch (error) {
            console.log(error);
        }
    }

    checkANextPrev() {
        this.aNextPage = document.getElementById('aNextPage');
        this.aPrevPage = document.getElementById('aPrevPage');
        if (!this.aNextPage || this.aNextPage == null) {
            var aTag = document.createElement('a');
            aTag.setAttribute('id', "aNextPage");
            this.nextButton.appendChild(aTag);
            this.aNextPage = document.getElementById('aNextPage');
        }

        if (!this.aPrevPage || this.aPrevPage == null) {
            var aTag = document.createElement('a');
            aTag.setAttribute('id', "aPrevPage");
            this.previousButton.appendChild(aTag);
            this.aPrevPage = document.getElementById('aPrevPage');
        }
    }

    removeExistingPaginationLinks() {
        this.paginationList.querySelectorAll("li").forEach(n => {
            n.remove();
        });
    };

    reAttachPaginationLinks() {
        this.paginationList = document.querySelector('.sd-pagination__list');
        this.el = document.querySelector(".sd-pagination");


        this.previousButton = this.el.querySelector(".sd-pagination__previous");
        this.nextButton = this.el.querySelector(".sd-pagination__next");
    }

    setTabValue(e) {
        let li = e.target.parentNode.parentNode;
        let tabID = li.getAttribute("id");
        PaginatedData.setTab(tabID);
    }

    generateItems() {
        var searchParams = this.getSearchParamsFromURL();
        var queryChar = "?";
        if (searchParams.length > 1) {
            queryChar = "&";
        }

        this.totalPage = this.el.getAttribute("data-totalpages");
        this.removeExistingPaginationLinks();
        this.visibleItems = 3;
        this.visibleItems = this.totalPage < this.visibleItems ? this.totalPage : this.visibleItems;
        var PageNumber = 0;
        if (parseInt(this.currentPage) >= 3) {
            PageNumber = this.totalPage < this.currentPage + 2 ? this.totalPage - 2 : this.currentPage - 1;
        }

        for (let i = 1; i <= this.visibleItems; i++) {
            const item = document.createElement("li");
            const link = document.createElement("a");
            item.classList.add("sd-pagination__item");
            link.classList.add("sd-pagination__link");
            let regex = /\/$/;
            var hostPath = window.location.host + window.location.pathname + searchParams;
            let result = hostPath.replace(regex, "");
            if(this.currentPage < 3){
                PageNumber = i;
            }
            var urlLink = "";
            urlLink = window.location.protocol + "//" + result + queryChar + "page=" + PageNumber;

            link.setAttribute("href", urlLink);
            link.textContent = PageNumber;
            link.setAttribute("data-page", PageNumber);
            item.insertAdjacentElement("beforeend", link);
            this.paginationList.insertAdjacentElement("beforeend", item);
            PageNumber ++
        }
        this.setPaginationLink();
    }

    setPaginationLink() {
        var searchParams = this.getSearchParamsFromURL();
        var queryChar = "?";
        if (searchParams.length > 1) {
            queryChar = "&";
        }

        const listItems = this.paginationList.querySelectorAll('li > a');
        [...listItems].forEach((item) => {
            let v = item.textContent;

            //Set href to paginated links
            let regex = /\/$/;
            var hostPath = window.location.host + window.location.pathname + searchParams;
            let result = hostPath.replace(regex, "");
            var urlLink = "";

            urlLink = window.location.protocol + "//" + result + queryChar + "page=" + v;

            item.setAttribute("href", urlLink);

            v = parseInt(v, 10);
            item.classList.remove("sd-pagination__item--active");
            if (v === this.currentPage) {
                item.setAttribute("rel", "canonical");
                item.classList.add("sd-pagination__item--active");
            }
            else if (this.currentPage > v)
                item.setAttribute("rel", "prev");
            else
                item.setAttribute("rel", "next");
            item.addEventListener("click", this.changePage);
        });

        this.totalPage = parseInt(this.totalPage, 10);
        this.checkANextPrev();
        // disable previous button when in first page
        if (this.currentPage > 1) {
            this.previousButton.classList.remove('sd-pagination__item--disabled');
            this.aPrevPage.setAttribute("rel", "prev");
        } else {
            this.previousButton.classList.add('sd-pagination__item--disabled');
            this.aPrevPage.removeAttribute("rel");
        }

        // disable next button when in last page
        if (this.currentPage === this.totalPage) {
            this.nextButton.classList.add("sd-pagination__item--disabled");
            this.aNextPage.remove();//Attribute("rel");
        } else {
            this.nextButton.classList.remove("sd-pagination__item--disabled");
            this.aNextPage.setAttribute("rel", "next");
        }

        if (this.currentPage === 1) {
            this.aPrevPage.remove();
        }
    }

    scrollToTop(offset) {
        const yCoord = this.contentEl.getBoundingClientRect().top + window.scrollY;
        window.scroll({
            top: yCoord + offset,
            behavior: "smooth",
        });
    }

    next(event) {
        var searchParams = this.getSearchParamsFromURL();
        var queryChar = "?";
        if (searchParams.length > 1) {
            queryChar = "&";
        }

        event.preventDefault();
        this.currentPage = parseInt(this.currentPage) + 1;
        var arrPageTitle = this.PageTitle.split('|');
        if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() };
        document.title = "Page " + this.currentPage + " | " + arrPageTitle.join("|");
        this.totalPage = this.el.getAttribute("data-totalpages");
        var PageNumber = 0;

        if(this.currentPage >= 3){
            PageNumber = this.totalPage < this.currentPage + 2 ? this.totalPage - 2 : this.currentPage - 1;
            const listItems = this.paginationList.querySelectorAll('li > a');
            listItems.forEach(item => {
                item.setAttribute("data-page", PageNumber);
                item.innerHTML = PageNumber;
                PageNumber ++;
            });
        }

        //Set URL of the accessed page
        let regex = /\/$/;
        var hostPath = window.location.host + window.location.pathname + searchParams;
        let result = hostPath.replace(regex, "");
        const itemsPerPageElement = document.querySelector('[data-itemsperpage]');
        let itemsPerPage = 0;
        if (itemsPerPageElement != null) {
            itemsPerPage = parseInt(itemsPerPageElement.getAttribute('data-itemsperpage'));
        }
        if (this.currentPage <= this.totalPage) {
            this.getPaginatedData(event);
            this.setPaginationLink();
            this.checkANextPrev();
            this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
            if (this.currentPage < this.totalPage)
                this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
            else if (this.currentPage == this.totalPage) {
                this.aNextPage.remove();//Attribute("href");
            }
        }
        var urlLink = window.location.protocol + "//" + result + queryChar + "page=" + parseInt(this.currentPage, 10);

        window.history.pushState(null, '', urlLink);
        document.querySelector("link[rel='canonical']").href = urlLink;
        if (itemsPerPageElement != null) {
            this.updatePagination(this.currentPage, itemsPerPage, this.totalPage, this.resultType);
        }
        this.appendPageNumberToHeading();
    }

    appendPageNumberToHeading() {
        this.queryParams = new URLSearchParams(window.location.search);
        if (this.queryParams) {
            this.queryParamsValue = Object.fromEntries(this.queryParams.entries());
        }
        if (window.location.href.indexOf("page=") > -1) {
            document.getElementsByClassName("sd-read-more-content")[0].style.display = "none";
            document.getElementsByClassName("sd-global__content")[0].style.display = "none";

            this.readMoreContentParentDiv = document.getElementsByClassName("sd-read-more-content")[0];
            this.readMoreContentChildDiv = this.readMoreContentParentDiv.childNodes[1].innerHTML;
            this.globalContentParentDiv = document.getElementsByClassName("sd-global__content")[0].getElementsByTagName('p');

            if (this.pageFlag == false) {
                sessionStorage.setItem("sd-read-more-content", this.readMoreContentChildDiv);
                for (let i = 0; i < this.globalContentParentDiv.length; i++) {
                    sessionStorage.setItem("sd-global-content" + i, this.globalContentParentDiv[i].innerHTML);
                }
                this.pageFlag = true;
            }
            for (let i = 0; i < this.globalContentParentDiv.length; i++) {
                this.globalContentChildArr[i] = this.globalContentParentDiv[i].innerHTML;
                this.globalContentParentDiv[i].innerHTML = "";
            }
            this.readMoreContentParentDiv.childNodes[1].innerHTML = "";

            if (window.innerWidth > 768)
                document.getElementsByClassName("on-site-filter")[0].style.marginTop = '50px';
            if (this.queryParamsValue["page"]) {
                this.currentPage = this.queryParamsValue["page"];
                document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText + " - Page " + this.currentPage;
            } else {
                document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText + " - " + this.capitalize((window.location.href.split('page')[1]).replace(/[=]/g, "Page "));
            }
        }
        else {
            this.readMoreContentParentDiv.childNodes[1].innerHTML = sessionStorage.getItem("sd-read-more-content");
            for (let i = 0; i < this.globalContentParentDiv.length; i++) {
                this.globalContentParentDiv[i].innerHTML = sessionStorage.getItem("sd-global-content" + i);
            }
            document.getElementsByClassName("sd-read-more-content")[0].style.display = "block";
            document.getElementsByClassName("sd-global__content")[0].style.display = "block";
            document.getElementsByClassName("on-site-filter")[0].style.marginTop = '20px';
            document.getElementsByClassName("sd-h3")[0].innerHTML = this.originalText;
        }
    }
    capitalize(s) { return s[0].toUpperCase() + s.slice(1); }

    previous(event) {
        var searchParams = this.getSearchParamsFromURL();
        var queryChar = "?";
        if (searchParams.length > 1) {
            queryChar = "&";
        }
        event.preventDefault();
            
        if(this.currentPage >= 3){
            let PageNumber = this.currentPage === 2 ? this.currentPage - 1 : this.currentPage - 2;
            const listItems = this.paginationList.querySelectorAll('li > a');
            listItems.forEach((item) => {
                item.setAttribute("data-page", PageNumber);
                item.innerHTML = PageNumber;
                PageNumber++;
            });
        }
        const itemsPerPageElement = document.querySelector('[data-itemsperpage]');
        let itemsPerPage = 0;
        if (itemsPerPageElement != null) {
            itemsPerPage = parseInt(itemsPerPageElement.getAttribute('data-itemsperpage'));
        }
        this.currentPage = this.currentPage - 1;
        //Set URL of the accessed page
        let regex = /\/$/;
        var hostPath = window.location.host + window.location.pathname + searchParams;
        let result = hostPath.replace(regex, "");
        this.checkANextPrev();
        this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
        if (parseInt(this.currentPage, 10) == 1) {
            document.title = this.PageTitle;
            this.aPrevPage.remove();//Attribute("href");
        }
        else {
            var arrPageTitle = this.PageTitle.split('|');
            if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
            document.title = "Page " + this.currentPage + " | " + arrPageTitle.join("|");// this.PageTitle;
            this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
        }
        if (this.currentPage >= 0) {
            this.getPaginatedData(event);
            this.setPaginationLink();
        }
        var urlLink = "";

        if (itemsPerPageElement != null) {
            this.updatePagination(this.currentPage, itemsPerPage, this.totalPage, this.resultType);
        }
        urlLink = window.location.protocol + "//" + result + queryChar + "page=" + parseInt(this.currentPage, 10);

        window.history.pushState(null, '', urlLink);
        document.querySelector("link[rel='canonical']").href = urlLink;
        this.appendPageNumberToHeading();
    }

    async getProductSearchDataFromAPI(url, method) {
        await HttpClient.AsyncGetRequest(url, method)
            .then(result => {
                let paginationData = JSON.parse(result);
                this.contentEl.innerHTML = "";
                this.contentEl.insertAdjacentHTML("beforeend", paginationData.result);
                this.scrollToTop(-350);
                const observer = lozad();
                observer.observe();
            })
            .catch(error => {
                console.error(error)
            });
    }

    async getTeamsDataFromApi(url, method) {
        await HttpClient.AsyncGetRequest(url, method)
            .then(result => {
                let paginationData = document.querySelector(".meet-the-team__members-grid");
                paginationData.innerHTML = "";
                paginationData.insertAdjacentHTML("beforeend", result);
                this.scrollToTop(-350);
                const observer = lozad();
                observer.observe();
            })
            .catch(error => {
                console.error(error)
            });
    }

    async getFilteredDataFromApi(url, method) {
        await HttpClient.AsyncGetRequest(url, method)
            .then(result => {
                let paginationData = JSON.parse(result);
                this.contentEl.innerHTML = "";
                this.contentEl.insertAdjacentHTML("beforeend", paginationData.result);
                this.scrollToTop(-350);
                const observer = lozad();
                observer.observe();
            })
            .catch(error => {
                console.error(error)
            });
    }

    getSelectedTab() {
        let selectedTab = PaginatedData.getTab();
        return selectedTab
    }

    getSelectedFilter = () => {
        let selectedFilter = PaginatedData.getFilter();
        return selectedFilter;
    }

    async getPaginatedData(event) {
        var currentPage;
        var areas = [];
        var grades = [];
        var types = [];

        if (this.queryParamsValue["area"] || this.queryParamsValue["grade"] || this.queryParamsValue["tag"]) {
            if (this.queryParamsValue["area"]) {
                this.queryParamsValue["area"] = decodeURIComponent(this.queryParamsValue["area"]);
                let areaUrlParamsList = this.queryParamsValue["area"].split("|");
                for (var i = 0; i < areaUrlParamsList.length; i++) {
                    areas.push({ Title: areaUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["grade"]) {
                this.queryParamsValue["grade"] = decodeURIComponent(this.queryParamsValue["grade"]);
                let typeUrlParamsList = this.queryParamsValue["grade"].split("|");
                for (var i = 0; i < typeUrlParamsList.length; i++) {
                    grades.push({ Title: typeUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["tag"]) {
                this.queryParamsValue["tag"] = decodeURIComponent(this.queryParamsValue["tag"]);
                let gradeUrlParamsList = this.queryParamsValue["tag"].split("|");
                for (var i = 0; i < gradeUrlParamsList.length; i++) {
                    types.push({ Title: gradeUrlParamsList[i] });
                }
            }

            if (this.queryParamsValue["page"]) {
                currentPage = this.queryParamsValue["page"];
            }
        }
        event.preventDefault();
        const jsonSetting = JSON.parse(PaginatedData.getSearchSettings());
        let isSearch = PaginatedData.getSearchflag();

        if (this.currentPage) {
            currentPage = this.currentPage
        }

        const data = {
            pageid: jsonSetting != null ? jsonSetting.PageId : this.itemId,
            page: currentPage,
            currenturl: location.href.toLowerCase(),
            filter: this.getSelectedFilter(),
            isSearchPage: isSearch,
            q: PaginatedData.getURLqueryString(),
            tab: jsonSetting != null ? jsonSetting.Tab : this.getSelectedTab(),
            areas: jsonSetting != null ? jsonSetting.Areas : areas,
            tags: jsonSetting != null ? jsonSetting.Tags : types,
            grades: jsonSetting != null ? jsonSetting.Grades : grades
        }

        //Append parameters
        const url = `${this.url}?data=${encodeURIComponent(JSON.stringify(data))}`;
        if (isSearch) {
            await this.getFilteredDataFromApi(url, this.method);
        } else if (this.isProductSearch) {
            await this.getProductSearchDataFromAPI(url, this.method);
        } else {
            await this.getTeamsDataFromApi(url, this.method);
        }
    }

    updatePagination(currentPage, itemsPerPage, totalPage, resultType) {
        //rebuild the pagination navigation incase it's required by pages with multiple filters
        if (this.navItems.length <= this.visibleItems) {
            this.generateItems();
        }
        this.currentTab = PaginatedData.getTab();

        if (this.queryParamsValue["page"]) {
            PaginatedData.setCurrentPage(currentPage);
        }
        this.totalResults = this.el.getAttribute("data-totalresults");
        var paginationTabEl = document.querySelector(`.tab-${this.currentTab}`) ?? document.querySelector(`.search-list__content__pagination`);
        const paginationSpans = paginationTabEl.querySelectorAll(".sd-subtitle");
        const endItem = Math.min(currentPage * itemsPerPage, this.totalResults);

        //check if results count are plural or not, this is to change the text of the result type to the correct plural form
        if (endItem === 1) {
            if (resultType == "Things to Do") {
                resultType = "Thing to Do";
            } else if (resultType == "Hotels") {
                resultType = "Hotel";
            } else if (resultType == "Tour Ideas") {
                resultType = "Tour Idea";
            }
        }

        if (currentPage == 1) {
            const startItem = 1;
            if (paginationSpans) {
                paginationSpans.forEach((span) => {
                    span.textContent = `${startItem} - ${endItem} of ${this.totalResults} ${resultType}`;
                });
            }
        } else {
            if (currentPage < totalPage) {
                const startItem = (currentPage - 1) * itemsPerPage + 1;

                if (paginationSpans) {
                    paginationSpans.forEach((span) => {
                        span.textContent = `${startItem} - ${endItem} of ${this.totalResults} ${resultType}`;
                    });
                }
            } else if (currentPage == totalPage) {
                const startItem = (currentPage - 1) * itemsPerPage + 1;
                if (paginationSpans) {
                    paginationSpans.forEach((span) => {
                        span.textContent = `${startItem} - ${this.totalResults} of ${this.totalResults} ${resultType}`;
                    });
                }
            }
        }
    }

    getSearchParamsFromURL() {
        var searchParams = ""
        let searchQueryItem = window.location.search.includes("%20&%20") ? window.location.search.replace("%20&%20", " %26 ") : window.location.search;

        this.queryParams = new URLSearchParams(searchQueryItem);
        if (this.queryParams) {
            this.queryParamsValue = Object.fromEntries(this.queryParams.entries());
        }
        for (var object in this.queryParamsValue) {
            if (object != "page") {
                if (searchParams.length <= 1) {
                    searchParams += "?" + object + "=" + this.queryParamsValue[object];
                } else {
                    searchParams += "&" + object + "=" + this.queryParamsValue[object];
                }
            }
        }

        return searchParams;
    }

    changePage(event,urlPageParam) {
        event.preventDefault();
        var searchParams = this.getSearchParamsFromURL();
        var pageId;
        var queryChar = "?";

        if (searchParams.length > 1) {
            queryChar = "&";
        }
        if(event.type!="popstate"){
            const link = event.target;
            pageId = link.getAttribute("data-page");
        }else{
            pageId = urlPageParam;
        }

        this.currentPage = parseInt(pageId, 10);
        //Set URL of the accessed page
        let regex = /\/$/;
        var hostPath = window.location.host + window.location.pathname + searchParams;
        let result = hostPath.replace(regex, "");
        this.checkANextPrev();
        const itemsPerPageElement = document.querySelector('[data-itemsperpage]');
        let itemsPerPage = 0;
        if (itemsPerPageElement != null) {
            itemsPerPage = parseInt(itemsPerPageElement.getAttribute('data-itemsperpage'));
        }
        // Update page title and pagination spans
        if (parseInt(this.currentPage, 10) == 1) {
            document.title = this.PageTitle;
            this.aPrevPage.remove();
            this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
            if (itemsPerPageElement != null) {
                this.updatePagination(this.currentPage, itemsPerPage, this.totalPage, this.resultType);
            }
        } else {
            var arrPageTitle = this.PageTitle.split('|');
            if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
            document.title = "Page " + this.currentPage + " | " + arrPageTitle.join("|");

            if (this.currentPage < this.totalPage) {
                this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
                this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
                if (itemsPerPageElement != null) {
                    this.updatePagination(this.currentPage, itemsPerPage, this.totalPage, this.resultType);
                }
            } else if (this.currentPage == this.totalPage) {
                this.aNextPage.remove();
                this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
                if (itemsPerPageElement != null) {
                    this.updatePagination(this.currentPage, itemsPerPage, this.totalPage, this.resultType);
                }
            }
        }

        if (parseInt(this.currentPage, 10) == 1) {
            document.title = this.PageTitle;
            this.aPrevPage.remove();//Attribute("href");
            this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
        }
        else {
            var arrPageTitle = this.PageTitle.split('|');
            if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
            document.title = "Page " + this.currentPage + " | " + arrPageTitle.join("|");// this.PageTitle;
            if (this.currentPage < this.totalPage) {
                this.aNextPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) + 1);
                this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
            }
            else if (this.currentPage == this.totalPage) {
                this.aNextPage.remove()//Attribute("href");
                this.aPrevPage.href = window.location.protocol + "//" + result + queryChar + "page=" + (parseInt(this.currentPage) - 1);
            }
        }
        var urlLink = "";
        if (this.currentPage == 1){
            urlLink = window.location.protocol + "//" + result;
        }
        else{
            urlLink = window.location.protocol + "//" + result + queryChar + "page=" + this.currentPage;
        }
        window.history.pushState(null, '', urlLink);
        this.setPaginationLink(event);
        this.getPaginatedData(event);
        if (document.getElementsByClassName("sd-read-more-content")[0] || document.getElementsByClassName("sd-global__content")[0]) {
            this.appendPageNumberToHeading();
        }
    }
}

export default PaginatedContent;